import SweetAlert from "react-bootstrap-sweetalert";
import { Button, Card, Container, Row, Col } from "react-bootstrap";
import React, { useEffect, useCallback, useMemo, useState } from "react";
import { fetchSimulation, fetchSimulationForListe, fetchSimulationOnly, SimulationDeleted, verifExistance } from "../../Redux/simulationReduce";
import { useDispatch } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import { useHistory } from "react-router";
import MaterialReactTable from 'material-react-table';
import { useTranslation } from 'react-multi-lang';
import { MRT_Localization_FR } from "material-react-table/locales/fr";
import { MRT_Localization_EN } from "material-react-table/locales/en";
import DownloadFileCell from "./DownloadFileCell";


function list_Simulation({ client }) {
    const dispatch = useDispatch();
    const navigate = useHistory();
    let lang = window.localStorage.getItem("lang");
    const t = useTranslation();
    const [loader, setLoader] = React.useState(true);
    const [alert, setAlert] = React.useState(null);
    const [entities, setEntities] = React.useState([]);
    const ans = JSON.parse(localStorage.getItem("annee"));



    const getinfo = useCallback(
        async (rowId) => {
            var root = await dispatch(fetchSimulationOnly({ id: rowId }));
            exportToexcel(root.payload.arrayPrixProd);
        },
        [dispatch]
    );



    const columns = useMemo(
        () => [
            {
                header: "Nom file",
                accessorKey: "titre",
            },
            {
                header: "Mois",
                accessorKey: "mois",
            },
            {
                header: "Année",
                accessorKey: "annee",
            },
            {
                header: "Date insertion ",
                accessorKey: "createdAt",
            },
            {
                accessorKey: 'nom_file_details',
                header: 'Télécharger file générer',
                Cell: ({ cell, row }) => (
                    <div className="actions-right block_action">
                        <DownloadFileCell nom_file={cell.row.original.nom_file_details} />
                    </div>
                ),
            }, {
                accessorKey: 'detail',
                header: 'Détails',
                Cell: ({ cell, row }) => (
                    <div className="actions-right block_action">
                        {console.log(client + "/simulationCommande/detail/" + cell.row.original.id)}
                        <Button
                            className=" mr-1 float-left"
                            type="button"
                            variant="info"
                            onClick={() => {
                                navigate.push(client + "/simulationCommande/detail/" + cell.row.original.id);
                            }}
                        >
                            <i className="fas fa-eye"></i>
                        </Button>
                    </div>
                ),
            },
            {
                accessorKey: 'filenameinserer',
                header: 'Télécharger Fichier Insérer',
                Cell: ({ cell }) => (
                    <div className="actions-right block_action">
                        {cell.row.original.filenameinserer != null ? <DownloadFileCell nom_file={cell.row.original.filenameinserer} /> : null}
                    </div>
                ),
            },
            {
                accessorKey: 'id',
                header: 'Actions',
                Cell: ({ cell, row }) => (
                    <div className="actions-right block_action">
                        <Button
                            id={"idLigne_" + cell.row.original.id}
                            onClick={(e) => {
                                // confirmMessage(cell.row.original.id, e);
                                verif(cell.row.original.id)
                            }}
                            variant="danger"
                            size="sm"
                            className="btn-danger btn delete"
                        >
                            <i className="fa fa-trash" id={"idLigne_" + cell.row.original.id} />
                        </Button>
                        <Button
                            id={"idLigne_" + cell.row.original.id}
                            onClick={() => {
                                localStorage.setItem('mois', cell.row.original.mois)
                                localStorage.setItem('annee', cell.row.original.annee)
                                navigate.push(client + "/simulation/update/" + cell.row.original.id);
                            }}
                            variant="warning"
                            size="sm"
                            className="btn-warning btn mx-2 "
                        >
                            <i className="fa fa-pencil" id={"idLigne_" + cell.row.original.id} />
                        </Button>
                    </div>
                ),
            },
        ],
        [client]
    );

    const notify = (type, msg) => {
        if (type === 1)
            toast.success(
                <strong>{msg}</strong>
            );
        else
            toast.error(
                <strong>{msg}</strong>
            );
    };

    const hideAlert = () => {
        setAlert(null);
    };

    const confirmMessage = (id, e, test) => {
        setAlert(
            test === 1 ? (
                <SweetAlert
                    style={{ display: "block", marginTop: "-100px" }}
                    title="Êtes-vous sûr de continuer la suppression ? "
                    onConfirm={() => deleteSimulation(id, e)}
                    onCancel={() => hideAlert()}
                    confirmBtnBsStyle="info"
                    cancelBtnBsStyle="danger"
                    confirmBtnText="Oui"
                    cancelBtnText="Non"
                    showCancel
                />
            ) : (
                <SweetAlert
                    style={{ display: "block", marginTop: "-100px" }}
                    title="Êtes-vous sûr de continuer la suppression ? "
                    onConfirm={() => deleteSimulation(id, e)}
                    onCancel={() => hideAlert()}
                    confirmBtnBsStyle="info"
                    cancelBtnBsStyle="danger"
                    confirmBtnText="Oui"
                    cancelBtnText="Non"
                    showCancel
                />
            )
        );
    };


    function verif(id, e) {
        dispatch(verifExistance({ id })).then((val) => {
            var test = val.payload.test
            confirmMessage(id, e, test)
        });
    }


    function deleteSimulation(id, e) {
        dispatch(SimulationDeleted({ id })).then((val) => {
            notify(1, "Simulation supprimé avec succées")
            getSimulation();
            hideAlert();
        });
    }


    const getSimulation = useCallback(
        async () => {
            var root = await dispatch(fetchSimulationForListe({ annee: ans, client }));
            const extractedData = root.payload.map(item => {
                const mois = item.mois;
                const moisNoms = [
                    "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
                    "Juillet", "Aout", "Septembre", "Octobre", "Novembre", "Décembre"
                ];

                if (mois >= 1 && mois <= 12) {
                    return {
                        createdAt: item.createdAt.substring(0, 10),
                        nom_file: item.nom_file,
                        nom_file_details: item.nom_file_details,
                        filenameinserer: item.filenameinserer,
                        titre: item.titre,
                        id: item.id,
                        mois: moisNoms[mois - 1],
                        annee: item.annee,

                    };
                }

                return null; // Gérer les cas invalides ici
            });

            setLoader(false);
            setEntities(extractedData.filter(item => item !== null)); // Filtrer les éléments nuls
        },
        [dispatch]
    );

    function listepp() {
        navigate.push(client + "/ExtractionSimulation");
    }

    useEffect(() => {
        getSimulation();
    }, [getSimulation]);

    return (
        <>
            {alert}
            <Container fluid>
                <ToastContainer />
                <Row>
                    <Col md="12">
                        <Button
                            id="saveBL"
                            className="btn-wd btn-outline mr-1 float-left"
                            type="button"
                            variant="info"
                            onClick={listepp}
                        >
                            <span className="btn-label">
                                <i className="fas fa-plus"></i>
                            </span>
                            Ajouter Simulation Commande
                        </Button>
                    </Col>
                    <Col md="12">

                        <Card className="card-header">
                            <Card.Header><h4 className="title">Simulation Commande</h4></Card.Header>

                            <Card.Body>

                                <MaterialReactTable
                                    state={{ isLoading: loader }}
                                    columns={columns}
                                    data={entities}
                                    enableColumnActions={true}
                                    enableColumnFilters={true}
                                    enablePagination={true}
                                    enableSorting={true}
                                    enableBottomToolbar={true}
                                    enableTopToolbar={true}
                                    muiTableBodyRowProps={{ hover: false }}
                                    displayColumnDefOptions={{
                                        'mrt-row-numbers': {
                                            size: 10,
                                        },
                                        'mrt-row-expand': {
                                            size: 10,
                                        },
                                    }}
                                    enableColumnFilterModes
                                    initialState={{
                                        columnVisibility: { description: false },
                                        density: 'compact',
                                        showGlobalFilter: true,
                                    }}


                                    filterFns={{
                                        myCustomFilterFn: (row, id, filterValue) => {
                                            const value = row.getValue(id);
                                            return typeof value === 'string' && value.toLowerCase().includes(filterValue.toLowerCase());
                                        },
                                    }}
                                    globalFilterFn="myCustomFilterFn"

                                    muiSearchTextFieldProps={{
                                        placeholder: t("search"),
                                        sx: { minWidth: '18rem' },
                                        variant: 'outlined',
                                    }}
                                    localization={
                                        lang === "fr"
                                            ? MRT_Localization_FR
                                            : MRT_Localization_EN
                                    }
                                />
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default list_Simulation;
